import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CustomButton } from '../CustomButton';
import { darken, useTheme } from '@mui/material';

interface BackButtonProps {
    onClick?: () => void;
    redirectTo?: string;
    sx?: object;
}

export default function BackButton({
    onClick,
    redirectTo,
    sx,
}: BackButtonProps) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) return onClick();
        if (redirectTo) return navigate(redirectTo);
        return navigate(-1);
    };

    const theme = useTheme();

    return (
        <CustomButton
            onClick={handleClick}
            variant='contained'
            color='inherit'
            sx={{
                position: 'absolute',
                left: -10,
                top: -5,
                display: { xs: 'none', sm: 'inline-flex' },
                transform: {
                    sm: 'translateX(calc(-100% - 16px))',
                    md: 'translateX(calc(-100% - 24px))',
                },
                minWidth: 0,
                width: { sm: 36, md: 40 },
                height: { sm: 36, md: 40 },
                p: 0,
                borderRadius: '50%',
                backgroundColor: theme.palette.policy.fair,
                color: theme.palette.neutral.main,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: darken(theme.palette.policy.fair, 0.15),
                    boxShadow: 'none',
                },
                ...sx,
            }}
        >
            <ArrowBackIcon fontSize='small' />
        </CustomButton>
    );
}
